import { useEffect } from 'react';

/**
 * Meta Pixel base code — Sideline Ready.
 * Fires a single PageView per page load. Guarded against React StrictMode
 * double-effects, remounts and any other script that already initialised fbq.
 */
const PIXEL_ID = '1419557570380098';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};
type PixelWindow = Window & {
  fbq?: Fbq;
  _fbq?: Fbq;
  __sidelinePixelPageViewSent?: boolean;
};
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || !PIXEL_ID) return;
    const w = window as PixelWindow;

    // Only one PageView per page load, no matter how many times this mounts.
    if (w.__sidelinePixelPageViewSent) return;
    w.__sidelinePixelPageViewSent = true;
    if (!w.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
      } as Fbq;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      w.fbq = fbq;
      if (!w._fbq) w._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return null;
}